import React from 'react'
import styled from 'styled-components'

export interface ICheckboxProps {
    isSelected: boolean,
    setIsSelected: (isSelected: boolean) => void
}

const Checkbox: React.FC<ICheckboxProps> = ({
    isSelected,
    setIsSelected
}) => {
    return (
        <CheckboxContainer>
            <CheckboxInput type='checkbox' checked={isSelected} onChange={(event) => setIsSelected(event.target.checked)}/>
            {
                isSelected && (
                    <Icon viewBox="0 0 24 24">
                        <polyline points="20 6 9 17 4 12" />
                    </Icon>
                )
            }
            <CheckboxLabel/>
        </CheckboxContainer>
    )
}

const CheckboxContainer = styled.label`
    display: block;
    position: relative;
    padding-left: 20px;
    padding-top: 20px;
    cursor: pointer;
    font-size: 22px;
    user-select: none;
`

const CheckboxInput = styled.input`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    & input:checked ~ span:after {
        display: block;
    }
`

const CheckboxLabel = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid ${({ theme }) => theme.color.greyer};
    border-radius: 4px;

    &:after {
        content: "";
        position: absolute;
        display: none;
    }

    :after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid ${({ theme }) => theme.color.greyer};
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
`

const Icon = styled.svg`
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    position: absolute;
    fill: none;
    stroke: ${({ theme }) => theme.color.greyer};
    stroke-width: 2px;
`

export default Checkbox
